import { useNotification } from "../../../hooks/useNotification";
import { useUpdatePrePaymentStatusMutation } from "../../../store/apiSlice/invoiceApiSlice";
import { BlurModal } from "../../newLayout/page/components/BlurModal/BlurModal";
import { AddToShipmentCss, DetailsOfOrderCss } from "../../newLayout/page/Allocation/AddToShipment";
import { ModalHeader } from "../../newLayout/page/components/PurchaseOrderDetails/TrackingStatus";
import { Button } from "../../newLayout/page/components/Button/Button";

const STATUS_COPY = {
  authorised: {
    header: "Authorise Prepayment",
    confirmSingle: "You're about to authorise this prepayment. Are you sure?",
    confirmMultiple: "You're about to authorise these prepayments. Are you sure?",
    button: "Authorise",
    loading: "Authorising...",
  },
  paid: {
    header: "Mark Prepayment as Paid",
    confirmSingle: "You're about to mark this prepayment as paid. Are you sure?",
    confirmMultiple: "You're about to mark these prepayments as paid. Are you sure?",
    button: "Mark as Paid",
    loading: "Updating...",
  },
};

/**
 * Confirmation modal to authorise or mark prepayments as paid.
 */
export const UpdatePrepaymentStatusModal = ({
  closeModal,
  prepayments = [],
  statusId,
  onSuccess,
  setSelectedOrder,
}) => {
  const [updateStatus, { isLoading }] = useUpdatePrePaymentStatusMutation();
  const notify = useNotification();
  const copy = STATUS_COPY[statusId];

  const handleSubmit = async event => {
    event.preventDefault();
    const ids = prepayments.map(item => item.id);

    try {
      const response = await updateStatus({ ids, status_id: statusId, prepayments }).unwrap();
      notify({ type: "success", message: response.detail });
      setSelectedOrder?.([]);
      onSuccess?.();
      closeModal();
    } catch (error) {
      const data = error?.data || {};
      const fieldMessage = [data.ids, data.status_id].flat().filter(Boolean).join(" ");
      notify({
        type: "error",
        message: data.detail || fieldMessage || "Failed to update prepayment status.",
      });
    }
  };

  if (!copy) return null;

  return (
    <BlurModal>
      <AddToShipmentCss>
        <ModalHeader headerName={copy.header} closeModal={closeModal} />
        <DetailsOfOrderCss>
          <p>{prepayments.length === 1 ? copy.confirmSingle : copy.confirmMultiple}</p>
          <ul>
            {prepayments.map(item => (
              <li key={item.id}>{item.name || item.reference}</li>
            ))}
          </ul>
        </DetailsOfOrderCss>

        <Button
          btnName={isLoading ? copy.loading : copy.button}
          handler={handleSubmit}
          classOfBtn="submitBtn"
        />
      </AddToShipmentCss>
    </BlurModal>
  );
};
